export default class SessionStorageService {
  getObjectItemByKey(key) {
    try {
      const item = JSON.parse(window.sessionStorage.getItem(key) || '{}');
      return item;
    } catch ({ message }) {
      return message;
    }
  }
  setItem(key, value) {
    if (!window && !window.sessionStorage) return;
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }
}
